import classNames from 'classnames';
import { IoMdClose } from 'react-icons/io';
import { Link } from 'react-router-dom';

import Button from '../../../components/Button';
import { PintoEbookSubmissionStatus } from '../../../core/graphql/types';
import { getDayTime } from '../../../utils/dayjs';
import { EBOOK_SUBMISSION_STATUS_CLASS_NAME, EBOOK_SUBMISSION_STATUS_LABEL } from '../constants/status';

export interface IPropsEbookSubmissionListItem {
  _id: string;
  fileName: string;
  status: PintoEbookSubmissionStatus;
  itemCount: number;
  actorUsername?: string | null;
  adminNote?: string | null;
  createdAt: string;
  onCancel?: () => void;
}

const DATE_FORMAT = 'DD-MM-YYYY hh:mm A';

const EbookSubmissionListItem = ({ _id, fileName, status, itemCount, actorUsername, adminNote, createdAt, onCancel }: IPropsEbookSubmissionListItem) => {
  return (
    <tr className="hover font-tt">
      <th>
        <Link to={`/ebookSubmissions/detail?id=${_id}`} className="hover:underline">
          {fileName}
        </Link>
      </th>
      <td>
        <div className={classNames('gap-2', EBOOK_SUBMISSION_STATUS_CLASS_NAME[status])}>
          <span>{EBOOK_SUBMISSION_STATUS_LABEL[status]}</span>
        </div>
      </td>
      <td>{itemCount}</td>
      <td className="text-colorsBrandWarmBlack02LabelSecondary">{actorUsername || '-'}</td>
      <td className="max-w-[280px] break-words whitespace-normal text-colorsBrandWarmBlack02LabelSecondary">
        <div className="whitespace-normal line-clamp-2">{adminNote || '-'}</div>
      </td>
      <td className="text-colorsBrandWarmBlack02LabelSecondary whitespace-nowrap">{getDayTime(createdAt, DATE_FORMAT)}</td>
      <th>
        <div className="flex items-center gap-8">
          <Link to={`/ebookSubmissions/detail?id=${_id}`}>
            <Button type="ghost" color="black" className="space-x-4">
              <span>View</span>
            </Button>
          </Link>

          {status === PintoEbookSubmissionStatus.Pending && (
            <Button type="ghost" color="red" className="space-x-4 text-colorsBrandRed01Primary" onClick={onCancel}>
              <IoMdClose />
              <span>Cancel</span>
            </Button>
          )}
        </div>
      </th>
    </tr>
  );
};

export default EbookSubmissionListItem;
